import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-style8',
  templateUrl: './card-style8.component.html',
  styleUrls: ['./card-style8.component.css']
})
export class CardStyle8Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
